import React from 'react';
import { InfoWindow } from '@vis.gl/react-google-maps';
import { StoryPopup } from '..';

interface FeaturedStoriesWindowsProps {
    stories: any[];
    openedStories: number[];
    focusedIndex: number;
    onClose: (index: number) => void;
    onFocus: (index: number) => void;
}

/**
 * FeaturedStoriesWindows - Displays info windows for featured stories on the map
 */
export const FeaturedStoriesWindows: React.FC<FeaturedStoriesWindowsProps> = ({
    stories,
    openedStories,
    focusedIndex,
    onClose,
    onFocus,
}) => {
    if (!stories || stories.length === 0) return null;

    return (
        <>
            {stories.map((story: any, index: number) => {
                if (!openedStories.includes(index)) return null;

                return (
                    <InfoWindow
                        key={story.properties.familyId}
                        position={{
                            lng: story.properties.geometry.coordinates[0],
                            lat: story.properties.geometry.coordinates[1]
                        }}
                        zIndex={focusedIndex === index ? 50 : 0}
                        disableAutoPan={true}
                        shouldFocus={false}
                        onCloseClick={() => onClose(index)}
                    >
                        <StoryPopup
                            story={story.properties}
                            handleFocused={onFocus}
                            index={index}
                        />
                    </InfoWindow>
                );
            })}
        </>
    );
};
